import * as Sentry from "@sentry/react";

export const initSentry = () => {
  Sentry.init({
    dsn: "https://454f69c895a2578e32aea71b6d48d754@o4510322085003264.ingest.us.sentry.io/4510419270041600",
    sendDefaultPii: true,
    integrations: [
      Sentry.feedbackIntegration({
        colorScheme: "system",
        autoInject: false,
        isNameRequired: true,
        isEmailRequired: true,
      }),
    ],
  });
};
